export { default as LoadingDots } from './component';
